export default __webpack_public_path__ + "static/media/2BK96PF-min.52a9b3c7.jpeg";